import { HealthDataProvider } from './services/HealthDataContext';
import { DataSourceModeProvider } from './services/useDataSourceMode';
import { AppRouter } from './router/AppRouter';
import './theme/theme.css';
import './App.css';

export function App() {
  return (
    <DataSourceModeProvider>
      <HealthDataProvider>
        <AppRouter />
      </HealthDataProvider>
    </DataSourceModeProvider>
  );
}
